
import { Component, mixins, Prop } from 'nuxt-property-decorator';
import ProductSupply from '~/mixins/ProductSupply';
import Badge from '~/components/UIComponents/Badge.vue';

@Component({
  components: { Badge },
})
export default class SupplyRemainingBadge extends mixins(ProductSupply) {
  @Prop({ type: String, default: 'g-background-primary' })
  backgroundColor!: string;
  @Prop({ type: String, default: 'g-text-primary' })
  color!: string;

  get percentLeft() {
    if (!this.totalSupply || this.completelySoldOut) {
      return 0;
    }
    return this.item.qtyLeft / this.totalSupply;
  }

  get shouldShowSupply() {
    return (
      (!!this.item?.tiers?.length && this.supplyInTier) || this.supplyLimit
    );
  }

  get supplyA11yLabel() {
    if (this.completelySoldOut) {
      return this.$t('components.store.checkout.soldOut');
    }

    if (this.percentLeft <= 0.5) {
      return !!this.item?.tiers?.length
        ? this.$t('components.films.filmItemForSale.supplyRemainingInTier', {
            remaining: this.formattedQtyLeft,
            total: this.formattedTotalSupply,
          })
        : this.$t('components.films.filmItemForSale.supplyRemainingInStock', {
            remaining: this.formattedQtyLeft,
            total: this.formattedTotalSupply,
          });
    }

    return this.supplyTotalText;
  }

  get supplyTotalText() {
    if (!!this.item.burnsAt) {
      return !!this.item?.tiers?.length
        ? this.$t('components.films.filmItemForSale.supplyInTierTotalOrLess', {
            total: this.formattedTotalSupply,
          })
        : this.$t('components.films.filmItemForSale.supplyInStockTotalOrLess', {
            total: this.formattedTotalSupply,
          });
    }

    return !!this.item?.tiers?.length
      ? this.$t('components.films.filmItemForSale.supplyInTier', {
          total: this.formattedTotalSupply,
        })
      : this.$t('components.films.filmItemForSale.supplyInStock', {
          total: this.formattedTotalSupply,
        });
  }

  get supplyRemainingText() {
    return this.$t('components.films.filmItemForSale.supplyRemaining', {
      remaining: this.formattedQtyLeft || 0,
      total: this.formattedTotalSupply,
    });
  }

  get supplyMintedText() {
    return this.$t('components.films.filmItemForSale.totalMinted', {
      total: this.formattedTotalSupply,
    });
  }

  get formattedQtyLeft() {
    return this.item ? this.formatNumber(this.item.qtyLeft) : undefined;
  }

  get formattedTotalSupply() {
    return this.item ? this.formatNumber(this.totalSupply) : undefined;
  }

  get totalSupply() {
    return !!this.item.tiers?.length ? this.supplyInTier : this.supplyLimit;
  }

  formatNumber(n: number) {
    return (
      this.$options.filters?.formatNumber(n, n > 100000 ? '0,0 a' : '0,0') || n
    );
  }
}
